module.exports = __webpack_public_path__ + "static/media/off.08bc94b9.png";